import {
    SECONDS_IN_MINUTE,
    MINUTES_IN_HOUR,
    HOURS_IN_DAY
} from './constants';

export const convertSecondsToMinutes = seconds => seconds / SECONDS_IN_MINUTE;
export const convertMinutesToHours = minutes => minutes / MINUTES_IN_HOUR;
export const convertHoursToDays = hours => hours / HOURS_IN_DAY;
export const convertSecondsToHours = seconds => convertMinutesToHours(
    convertSecondsToMinutes(seconds)
);
export const convertSecondsToDays = seconds => convertHoursToDays(
    convertSecondsToHours(seconds)
);

export const convertMinutesToSeconds = minutes => minutes * SECONDS_IN_MINUTE;
export const convertHoursToMinutes = hours => hours * MINUTES_IN_HOUR;
export const convertDaysToHours = days => days * HOURS_IN_DAY;
export const convertHoursToSeconds = hours => convertMinutesToSeconds(
    convertHoursToMinutes(hours)
);
export const convertDaysToSeconds = days => convertHoursToSeconds(
    convertDaysToHours(days)
);
